import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../services/auth/auth.service'
import { Event, NavigationEnd, Router } from '@angular/router'
import { Observable } from 'rxjs'
import { Store } from '@ngrx/store'
import { AppState } from '../../state/app-state'
import { MeMedService } from '../../services/me-med/me-med.service'
import { ModalMedicalCertificateComponent } from '../modals/modal-medical-certificate/modal-medical-certificate.component'
import { HiddenLoading, ShowLoading } from '../../state/loading/loading.action'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { MeMed } from '../../models/me-med'
import { StatsService } from '../../services/stats/stats.service'
import { selectMevoValue, selectMevoId } from '../../state/mevo/mevo.selectors'
import { AppointmentsService } from '../../services/appointments/appointments.service'
import { take } from 'rxjs/operators'

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
	private meMed$?: Observable<MeMed>
	meMed?: MeMed
	mevo$?: any
	mevoId$?: any

	showMeMed?: boolean
	disabledMeMed: boolean = true
	disabledMevo: boolean = true

	constructor(
		private authService: AuthService,
		private router: Router,
		private store: Store<AppState>,
		private modalMedicalRest: NgbModal,
		private appointmentService: AppointmentsService,
		private meMedService: MeMedService,
		private statsService: StatsService
	) {
		this.meMed$ = this.store.select('meMed')
		this.mevo$ = this.store.select(selectMevoValue)
		this.mevoId$ = this.store.select(selectMevoId)

		this.mevo$.subscribe((valor: any) => {
			console.log('Valor atual de mevo:', valor)
			this.disabledMevo = valor // exemplo: desabilita botão se for false
		})

		this.mevoId$.subscribe((id: any) => {
			console.log('Valor atual de mevo:', id)
		})

		this.meMed$.subscribe((state) => {
			this.meMed = state
			if (this.meMed) {
				this.disabledMeMed =
					this.meMed.loading || this.meMed.error || !this.meMed.active
			}
		})

		this.router.events.subscribe((event: Event) => {
			if (event instanceof NavigationEnd) {
				this.showOptionsMeMed()
			}
		})
	}

	ngOnInit(): void {}

	showOptionsMeMed(): void {
		this.showMeMed = this.router.url.includes('/painel/consulta')
	}

	async openModuleMeMed() {
		if (!this.disabledMeMed) {
			this.statsService.stats('open_module_memed', 'point')
			await this.meMedService.showMeMed()
		}
	}

	async showMedicalRest(payload: { days: string; cid: string }) {
		await this.meMedService.medicalRest(payload)
	}

	openModalMedicalRest(): void {
		const self = this

		this.mevoId$.pipe(take(1)).subscribe((value: any) => {
			this.store.dispatch(ShowLoading())
			this.appointmentService.getIframe(value, {
				fnSuccess(response) {
					const modalRef = self.modalMedicalRest.open(
						ModalMedicalCertificateComponent,
						{
							size: 'xl',
							windowClass: 'modal-xxl',
						}
					)
					modalRef.componentInstance.title = 'Prescrição Mevo'
					modalRef.componentInstance.id = response.url
				},
				fnError(responseError) {
					// if (
					// 	responseError.status >= 400 &&
					// 	responseError.status < 500
					// ) {
					// 	self.toast.error(
					// 		'Ocorreu um erro na liberação do pacience da video chamada.'
					// 	)
					// } else {
					// 	self.toast.error(
					// 		`Status: ${responseError.status}`,
					// 		'Server Error!'
					// 	)
					// }
					// console.warn(responseError)
				},
				fnFinalized() {
					self.store.dispatch(HiddenLoading())
				},
			})
		})

		//@ts-ignore
		// modalRef.componentInstance.emmitEvent.subscribe(async (payload) => {
		// 	await this.showMedicalRest(payload)
		// })
	}

	logout() {
		this.authService.logout().subscribe(
			() => {
				this.authService.logOutSectionLocal().subscribe(() => {
					// @ts-ignore
					window.location = '/login'
				})
			},
			(err) => {
				console.warn(err)
			}
		)
	}
}
